import {
  Component,
  EventEmitter,
  Output,
  TemplateRef,
  ViewChild,
  inject,
} from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { SaveableFormComponent } from '@nimmsta/ng-commons-lib/forms';
import { SoftwareLabel } from '@nimmsta/ng-commons-lib/models';

@Component({
  template: '',
})
export abstract class SoftwareLabelFormComponent extends SaveableFormComponent<SoftwareLabel> {
  private fb = inject(FormBuilder);

  @Output() override closeEvent = new EventEmitter();

  @Output() override loadingEvent = new EventEmitter<boolean>();

  @ViewChild('resetModal', { static: true }) resetModal!: TemplateRef<unknown>;

  protected setFormGroup(): void {
    this.form = this.fb.group({
      id: this.value.id,
      name: [this.value.name, [Validators.required]],
      description: [this.value.description],
    });
  }
}
